// src/telemetry.ts
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS_KEY, // or instrumentationKey
    enableAutoRouteTracking: true,
    enableAjaxErrorStatusText: true,
    samplingPercentage: 50 // tune for cost/noise
  }
});

console.log('Initializing Application Insights with: ' + process.env.REACT_APP_APPLICATION_INSIGHTS_KEY);
appInsights.loadAppInsights();

export const logApplicationInsightsTrace = (message: string, props?: Record<string, any>) =>
  appInsights.trackTrace({ message, properties: props });

export const logApplicationInsightsError = (error: Error, props?: Record<string, any>) =>
  appInsights.trackException({ exception: error, properties: props });
